import React, {useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {formatDateToYearMonth} from '../../common-function/formatDateToYearMonth'
import SupportMessageFilter from './SupportMessageFilter'

const SupportMessagesWrapper = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [giftCards, setGiftCards] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [showFilter, setShowFilter] = useState<boolean>(false)
  const [page, setPage] = useState<number>(1)
  const [totalPages, setTotalPages] = useState(0)
  const [filterObject, setFilterObject] = useState<any>(null)
  const formattedMonth = formatDateToYearMonth(new Date())
  const toggleFilter = () => setShowFilter(!showFilter)

  const convertToHours = (timestamp: any) => {
    const date = new Date(timestamp)
    let hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12
    const strHours = hours.toString().padStart(2, '0')
    return `${strHours}:${minutes} ${ampm}`
  }

  // const fetchGiftCardData = async () => {
  //   let bodyData = {
  //     month: filterObject ? filterObject.month : formattedMonth,
  //     category: filterObject ? filterObject.category : '',
  //     page: page,
  //   }
  //   let response: any = await restRequest.getGiftCardData(bodyData)
  //   let data = response.data.data
  //   setGiftCards(data.data)
  //   setTotalPages(data.pager.totalPages)
  //   setIsLoading(false)
  // }

  // useEffect(() => {
  //   if (isLoading) fetchGiftCardData()
  // }, [page, filterObject, isLoading])

  const getPageNumbers = () => {
    let pages = []
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (page <= 3) {
        pages = [1, 2, 3, 4, 5, '...', totalPages]
      } else if (page >= totalPages - 2) {
        pages = [
          1,
          '...',
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        ]
      } else {
        pages = [1, '...', page - 1, page, page + 1, '...', totalPages]
      }
    }
    return pages
  }

  return (
    <div>
      <p className='card-label fw-bold fs-3 mb-2'>Support Messages</p>
      {isLoading ? (
        <div className=' d-flex justify-content-center mt-10 align-items-center border'>
          <div className='spinner-border text-primary'></div>
        </div>
      ) : (
        <div className={`card `}>
          <div className='card-header border-0 pt-5 d-flex justify-content-between'>
            <div>
              {/* <div className='d-flex align-items-center position-relative my-1'>
                  <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder='Search user'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div> */}
            </div>
            <div>
              <button
                disabled={isLoading}
                type='button'
                className='btn btn-light-primary me-3'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                onClick={() => setShowFilter(true)}
              >
                <KTIcon iconName='filter' className='fs-2' />
                Filter
              </button>
              {/* <button type='button' className='btn btn-light-primary me-3'>
                  <KTIcon iconName='exit-up' className='fs-2' />
                  Export
                </button> */}

              {/* <button type='button' className='btn btn-primary'>
            <KTIcon iconName='plus' className='fs-2' />
            Add User
          </button> */}
            </div>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-150px'>Email Subject</th>
                    <th className='min-w-140px'>Email Contact preview</th>
                    <th className='min-w-120px'>Date Received</th>
                    <th className='min-w-120px'>Time Received</th>
                    <th className='min-w-120px'>Status</th>
                    <th className='min-w-120px'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {giftCards.map((item: any, index: number) => {
                    let date: any = new Date().toLocaleDateString()

                    return ( */}
                  <tr>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary fs-6'>Saimon johnson</p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                        Credit Purchase
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>$15</p>
                    </td>
                    <td className='text-dark fw-bold text-hover-primary fs-6'>
                      {convertToHours(new Date())}
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                        {/* {convertToHours(item.createdAt)} */}
                        {new Date().toLocaleDateString()}
                      </p>
                    </td>{' '}
                    <td>
                      <a
                        href='#'
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      >
                        <KTIcon iconName='eye' className='fs-1' />
                      </a>
                    </td>
                  </tr>
                  {/* ) */}
                  {/* })} */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {totalPages > 1 && (
        <nav aria-label='Page navigation'>
          <ul className='pagination mt-5'>
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button className='page-link' onClick={() => setPage(page - 1)}>
                Previous
              </button>
            </li>
            {getPageNumbers().map((page, index) => (
              <li
                key={index}
                className={`page-item ${page === page ? 'active' : ''} ${
                  page === '...' ? 'disabled' : ''
                }`}
              >
                <button
                  className='page-link'
                  onClick={() => typeof page === 'number' && setPage(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
              <button className='page-link' onClick={() => setPage(page + 1)}>
                Next
              </button>
            </li>
          </ul>
        </nav>
      )}
      {showFilter && (
        <SupportMessageFilter
          showFilter={showFilter}
          toggle={toggleFilter}
          //   setFilterObject={setFilterObject}
          //   setIsLoading={setIsLoading}
        />
      )}
    </div>
  )
}

export default SupportMessagesWrapper
